import React from "react";

const EventCard = ({ event, onClick }) => {
  const formattedDate = new Date(event.dateAndHour).toLocaleDateString(
    "en-US",
    {
      weekday: "short",
      day: "numeric",
      month: "short"
    }
  );

  return (
    <div
      style={{
        backgroundColor: "white",
        borderRadius: "10px",
        boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
        overflow: "hidden",
        transition: "transform 0.3s ease, box-shadow 0.3s ease",
        display: "flex",
        flexDirection: "column",
        cursor: "pointer",
        maxWidth: "300px"
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.transform = "scale(1.05)";
        e.currentTarget.style.boxShadow = "0 4px 16px rgba(0, 0, 0, 0.2)";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.transform = "scale(1)";
        e.currentTarget.style.boxShadow = "0 2px 8px rgba(0, 0, 0, 0.1)";
      }}
      onClick={onClick}
    >
      <img
        src={event.image}
        alt={event.eventName}
        style={{
          width: "100%",
          height: "180px",
          objectFit: "cover"
        }}
      />
      <div style={{ padding: "15px", textAlign: "center" }}>
        <div
          style={{
            backgroundColor: "#000",
            color: "#fff",
            padding: "10px",
            borderRadius: "8px",
            fontSize: "14px",
            fontWeight: "bold",
            marginBottom: "10px"
          }}
        >
          {formattedDate}
        </div>
        <div
          style={{
            fontSize: "18px",
            fontWeight: "600",
            marginBottom: "10px"
          }}
        >
          {event.eventName}
        </div>
      </div>
    </div>
  );
};

export default EventCard;
